module.exports = __webpack_public_path__ + "img/logo-tomason-industrial.8cf53b99.png";